import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box } from "@mui/material";
import axios from "axios";
import Header from "./header";
import GeneralPanel from "./genrePanel";
import DashBoard from "./dashBoard";
import { config } from "../App";

const LandingPage = () => {
  let history = useHistory();
  const [filter, setfilter] = useState([]);
  const [select, setSelect] = useState([]);
  const [rating, setRating] = useState("");

  useEffect(() => {
    const performAPICall = async () => {
      try {
        const response = await axios.get(`${config.endpoint}/videos?genres=All`);
        setfilter(response.data.videos);
        return response;
      } catch (err) {
        console.log(err);
      }
    };

    performAPICall();
    // eslint-disable-next-line
  }, []);

  async function filterHandler(e) {
    let value = e.target.value;
    if (value === "Education" || value === "All") {
      value = e.target.value;
    } else {
      value = `Education,${e.target.value}`;
    }

    try {
      const filterResponse = await axios.get(`${config.endpoint}/videos?genres=` + value);
      setfilter(filterResponse.data.videos);
    } catch (err) {
      if (err.response.status === 404) {
        console.log("Page not found");
      } else {
        console.log(err);
      }
    }

    if (select.includes(e.target.value)) {
      setSelect(select.filter((o) => o !== e.target.value));
    } else {
      setSelect([...select, e.target.value]);
    }
  }

  async function contentRatingHandler(e) {
    setRating(e.target.value);
    let value = e.target.value;
    if (value === "Anyone") {
      value = e.target.value;
    } else {
      value = encodeURIComponent(value);
    }

    try {
      const filterResponse1 = await axios.get(
        value === "Anyone" ? `${config.endpoint}/videos?genres=All` : `${config.endpoint}/videos?contentRating=` + value
      );
      setfilter(filterResponse1.data.videos);
      return filterResponse1;
    } catch (err) {
      if (err.response.status === 404) {
        console.log("Page not found");
      } else {
        console.log(err);
      }
    }
  }

  function handleClick() {
    history.push("/VideoPage");
  }

  return (
    <Box>
      <Header navSetFilter={setfilter} />
      <GeneralPanel
        filterHandler={filterHandler}
        contentRatingHandler={contentRatingHandler}
        setfilter={setfilter}
        select={select}
        rating={rating}
      />
      <DashBoard filter={filter} handleClick={handleClick} />
    </Box>
  );
};

export default LandingPage;
